import React, { useState, useEffect, useRef, useCallback } from "react";
import "./NavigationContainer.css";
import { FaSearch, FaBell } from "react-icons/fa";
import { BiSolidMessageDetail } from "react-icons/bi";
import { useSelector, useDispatch } from "react-redux";
import { logoutUserThunk } from "../../../toolkit/slices/users/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Popover, Modal, Table, message, Row, Col } from "antd";
import { searchQuery as searchQueryAction } from "../../../toolkit/slices/inventories/inventorySlice";
import { throttle } from "lodash";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { IoAddCircleOutline } from "react-icons/io5";
import { IoNewspaperOutline } from "react-icons/io5";
import { BsCartPlus } from "react-icons/bs";

import _ from "lodash";
import moment from "moment";

function NavBarContainer() {
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  let count = useSelector((state) => state.cartSpace.cart).length;
  let userData = useSelector((state) => state.user);
  let searchQ = useSelector((state) => state.inventoriesList.searchQuery);
  const debounceTimeout = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const throttledSearch = useCallback(
    throttle((query) => { }, 1000), // Adjust throttle delay as needed (e.g., 300ms)
    [dispatch]
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    clearTimeout(debounceTimeout.current);
    setSearchQuery(value);
  };

  const debouncedSearch = useCallback(
    _.debounce((query) => {
      if (query) {
        dispatch(searchQueryAction(query));
      } else {
        dispatch(searchQueryAction(""));
      }
      navigate("/dashboard");
    }, 700), // Adjust the debounce delay as needed
    [dispatch, navigate]
  );
  const handleSearch = (e) => {
    setSearchQuery(e?.target?.value);
    debouncedSearch(e?.target?.value);
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setPagination({ current: 1, pageSize: 10 });
  };

  const handleCodeClick = (code) => {
    setSearchQuery(code);

    setIsModalVisible(false);

    navigator.clipboard
      .writeText(code)
      .then(() => {
        message.success(`Code ${code} copied to searchbar!`);
      })
      .catch((err) => {
        console.error("Error copying text: ", err);
        message.error("Failed to copy code to searchbar.");
      });

    debouncedSearch(code);
  };

  //this amigo handles the authorization by logging out if the cookie doesnt exist
  useEffect(() => {
    if (!Cookies.get("auth")) {
      dispatch(logoutUserThunk());
    }
  }, [dispatch]);
  useEffect(() => {
    if (!searchQ) {
      setSearchQuery("");
    }
  }, [searchQ]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 769);
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const fetchTableData = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       "https://za3u1gs11d.execute-api.ap-south-1.amazonaws.com/api/notification"
  //     );
  //     const rawData = await response.json();

  //     // Correctly access the 'data' property
  //     if (rawData && Array.isArray(rawData?.data)) {
  //       setTableData(rawData?.data);
  //     } else {
  //       console.error("Unexpected API response structure:", rawData);
  //       message.error("Failed to load table data.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching table data:", error);
  //     message.error("Error loading table data.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTableData();
  // }, []);

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  // Table Columns
  const tableColumns = [
    {
      title: "Code No",
      dataIndex: "CodeNo",
      key: "CodeNo",
      render: (text) => (
        <span
          style={{
            cursor: "pointer",
            color: "#1890ff",
            textDecoration: "underline",
          }}
          onClick={() => handleCodeClick(text)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Days Empty",
      dataIndex: "daysEmpty",
      key: "daysEmpty",
      render: (text) => (text ? text : "N/A"),
    },
    { title: "Area", dataIndex: "Area", key: "Area" },
    {
      title: "Last Booking Date",
      dataIndex: "LastBookingEndDate",
      key: "LastBookingEndDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "N/A"),
    },
    {
      title: "Suggested Brand Segment",
      dataIndex: "Popular_Brand_Segment",
      key: "Popular_Brand_Segment",
    },
    {
      title: "Suggested Brand",
      dataIndex: "Popular_Brand",
      key: "Popular_Brand",
    },
    {
      title: "Suggested Sales Person",
      dataIndex: "Popular_SalesPerson",
      key: "Popular_SalesPerson",
      render: (text) => (text ? text : "N/A"),
    },
  ];

  const content = (
    <div>
      <p style={{ fontWeight: "600", margin: "0" }}>{userData.name}</p>
      <h6 style={{ fontSize: "11px", color: "grey" }}>{userData.email}</h6>
      <Button
        style={{
          backgroundColor: "orange",
          color: "white",
          fontWeight: "600",
          marginTop: "0.5rem",
        }}
        onClick={() => dispatch(logoutUserThunk())}
      >
        Logout
      </Button>
    </div>
  );

  return (
    <>
      <section id="Navigation-bar">
        <div className="full-width">
          <Row>
            {location.pathname === "/dashboard" && (
              <Col lg={8}>
                <div className="search-bar-container">
                  <div className="input-box">
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleSearch}
                      onKeyPress={handleKeyPress}
                    />
                    <div onClick={handleSearch}>
                      <FaSearch />
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Col lg={location.pathname === "/dashboard" ? 16 : 24}>
              <div className="Navigation-option-container">
                <div className="options">
                  {/* <div>
                    <IoNewspaperOutline
                      onClick={handleModalOpen}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  </div> */}

                  <div>
                    <div
                      className="cart"
                      onClick={() => navigate("/inventory")}
                    >
                      <BsCartPlus />
                      {count > 0 ? <span>{count}</span> : null}
                    </div>
                  </div>
                  {/* <BiSolidMessageDetail style={{ display: isMobile ? 'none' : 'block' }} className="navigation-icons" />
              <FaBell style={{ display: isMobile ? 'none' : 'block' }} className="navigation-icons" /> */}
                  {/* <div>
                    <Link to="/add-inventory">
                      <IoAddCircleOutline style={{ color: "black" }} />
                    </Link>
                  </div> */}
                  <div>
                    <Popover placement="bottomLeft" content={content}>
                      <img
                        src={
                          userData.dp ||
                          "https://static.vecteezy.com/system/resources/previews/026/749/270/original/man-face-clipart-free-png.png"
                        }
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          cursor: "pointer",
                          marginTop: "-2px",
                        }}
                      />
                    </Popover>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Modal
        title="Available Inventories"
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={1100}
      >
        <Table
          components={components}
          dataSource={tableData}
          columns={tableColumns}
          rowKey={(record) => record.CodeNo || record.id}
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            onChange: (page, pageSize) => {
              setPagination({ current: page, pageSize });
            },
          }}
        />
      </Modal>

      <hr
        style={{
          marginBottom: "12px",
          border: "1px solid rgba(219, 219, 219, 1)",
        }}
      />
    </>
  );
}

export default NavBarContainer;
